import React, { useState, useRef } from "react"
import Select from 'react-select'
import { formatDistance } from 'date-fns'
import useSWR, { mutate } from 'swr'
import axios from 'axios'
import fetch from 'isomorphic-unfetch'
const fetcher = url => fetch(url).then(r => r.json())

function DevicesIndex(props){
  // fetch the data from our api using swr react hooks/fetch
  // this will also keep the data up-to-date
  const { data, error } = useSWR('/api/devices', fetcher)
  const [showForm, setShowForm] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [label, setLabel] = useState('')
  const [admin, setAdmin] = useState(false)
  const [selectedGroup, setSelectedGroup] = useState(null)
  const [device, setDevice] = useState({})

  const labelInput = useRef(null);
  const adminInput = useRef(null);

  const [showJSON, setShowJSON] = useState(false)
  function toggleShowJSON(){
    setShowJSON(!showJSON)
  }

  const changeLabel = (e) => {
    setLabel(e.target.value)
  }

  const changeAdmin = (e) => {
    setAdmin(!admin)
  }

  function toggleForm(){
    console.log("running toggle form")
    setShowForm(!showForm)
  }

  function dontToggle(event){
    event.stopPropagation()
  }

  function editDevice(device){
    console.log(device)
    setShowForm(true)
    setDevice(device)
    setLabel(device.label)
    setAdmin(device.admin)
    selectGroup(device.GroupId)
  }

  function clearForm(){
    setLabel('')
    setAdmin(false)
    selectGroup(null)
    setDevice({})

    labelInput.value = null
    adminInput.value = false
  }

  const submitEditForm = () => {
    if(label === ''){
      setErrorMessage('Fields not set')
    } else {
      setErrorMessage('')
      const formData = new FormData()
      formData.append('label', label)
      formData.append('admin', admin)
      formData.append('GroupId', (selectedGroup != null) ? selectedGroup.value : null)

      const endpoint = '/api/devices/' + device.id
      axios.post(endpoint, formData, {}).then(res => {
        console.log(res)
        // reset the form/reload the versions list
        clearForm()
        setErrorMessage('')
        setShowForm(false)

        // tell swr to refresh any data using this endpoint
        mutate('/api/devices')
      }).catch(err => {
        console.log(err)
      })
    }
  }

  const deleteDevice = () => {
    const endpoint = '/api/devices/delete/' + device.id

    const formData = new FormData()
    axios.post(endpoint, formData, {}).then(res => {
      console.log(res)
      // reset the form/reload the versions list
      clearForm()
      setErrorMessage('')
      setShowForm(false)

      // tell swr to refresh any data using this endpoint
      mutate('/api/devices')
    }).catch(err => {
      console.log(err)
    })
  }

  // TODO: turn these into components
  if (error) return <div className="loading"><p>Failed to load. The server is probably down.</p></div>
  if (!data) return <div className="loading"><p>Loading...</p></div>

  const groupOptions = data.groups.map(group => {
    return {
      value: group.id,
      label: group.title
    }
  })

  function selectGroup(groupId){
    var set = false
    for(var i = 0;i<groupOptions.length;i++){
      if(groupOptions[i].value === groupId) {
        set = true
        setSelectedGroup(groupOptions[i])
      }
    }
    if(!set) setSelectedGroup(null)
  }

  let connectedCount = 0
  console.log(data)
  for(let i = 0; i < data.devices.length; i++){
    data.devices[i].connected = false
    data.devices[i].connection = {}
    for(let j = 0; j < props.devices.length; j++){
      if(data.devices[i].uid === props.devices[j].deviceUniqueIdentifier){
        connectedCount++
        data.devices[i].connected = true
        data.devices[i].connection = props.devices[j]
      }
    }
  }
  console.log(data)

  return(
    <div>
      <h1>Devices <span className="subtitle">({connectedCount} connected)</span></h1>
      <div className="form" style={{ display: (showForm ? "block" : "none")}}  onClick={toggleForm}>
        <div className="form-modal" onClick={dontToggle} >
          <h3>Edit Device</h3>
          <p className='error-message'><b><i>{errorMessage}</i></b></p>
          <p><input ref={labelInput} type="text" value={label} placeholder="New Device" name="label" onChange={changeLabel}></input></p>
          <p>
            <span class="switchLabel">Admin Device</span>
            <label class="switch">
              <input ref={adminInput} type="checkbox" checked={admin} name="admin" onChange={changeAdmin}></input>
              <span class="slider round"></span>
            </label>
          </p>
          <Select value={selectedGroup} options={groupOptions} onChange={setSelectedGroup} />
          <p><button class="deleteBtn" onClick={deleteDevice}>Delete</button></p>
          <p><input type='submit' value='Save' onClick={submitEditForm} /></p>
        </div>
      </div>

      <GroupedDeviceTable groups={data.groups} devices={data.devices} editDevice={editDevice} />

      <div>
        <h1>JSON OUTPUT <button className="inline-control-small" onClick={toggleShowJSON}><span>{showJSON ? "hide" : "show"}</span></button></h1>
        <pre className={showJSON ? "" : "hidden"}>{JSON.stringify(data, null, 3)}</pre>
      </div>

    </div>
  )
}


function DeviceList(props){
  // map the data to JSX
  const devices = props.devices.map(device => (
    <div className="grid-item" key={device.id}>
      <h3><span class={"connection-indicator " + (device.connected ? 'connected' : 'disconnected') } ></span> {device.label} {device.admin ? "(admin)" : ""} <button className="inline-control-small inline-right" onClick={() => props.editDevice(device)}><span>edit</span></button></h3>
      <p>{device.model} <b># {device.serial}</b></p>
      <p>Last connected: <b><i>{formatDistance(new Date(device.updatedAt), new Date(), {addSuffix: true})} ({device.updatedAt})</i></b></p>
      <p class="subtitle">{device.uid}</p>
      <p>{device.os.split(' (')[0]}</p>
      <p><b>Installed Apps:</b></p>
      <DeviceAppVersionsList versions={device.Versions} />
    </div>
  ))

 return (
   <>
     {devices}
   </>
 )
}

function DeviceTable(props){
  // map the data to JSX
  const devices = props.devices.map(device => (
    <tr className="" key={device.id}>
      <td><button className="table-button" onClick={() => props.editDevice(device)}>edit</button></td>
      <td className="centered"><span className={"connection-indicator " + (device.connected ? 'connected' : 'disconnected') } ></span></td>
      <td classname="{device.connected ? 'bold' : ''}">{device.serial}</td>
      <td>{device.label}</td>
      <td className={"centered " + (device.admin ? 'bold' : '')}>{device.admin ? "yes" : "no"}</td>
      <td>{formatDistance(new Date(device.updatedAt), new Date(), {addSuffix: true})} <br/><i>({device.updatedAt})</i></td>
      <td>{device.model}<br />{device.deviceName}</td>
      <td>{device.os.split(' (')[0]}<br />{device.osVersion}</td>
      <DeviceAppVersionsColumns versions={device.Versions} />
    </tr>
  ))

 return (
   <>
     {devices}
   </>
 )
}

function GroupedDeviceTable(props){
  const [sortedField, setSortedField] = useState(null)
  const [sortDirection, setSortDirection] = useState(false)

  const changeSortedField = (name) => {
    if(sortedField == name){
      setSortDirection(!sortDirection)
    } else {
      setSortDirection(false)
      setSortedField(name)
    }
  }

  const groupdevices = []
  for(var i = 0;i<props.groups.length;i++){
    groupdevices[props.groups[i].id] = []
  }
  for(var j = 0;j<props.devices.length;j++){
    groupdevices[props.devices[j].GroupId].push(props.devices[j])
  }

  const groups = props.groups.map(group => {
    let gd = [...groupdevices[group.id]]
    if(sortedField !== null){
      gd.sort((a,b) => {
        if(a[sortedField] < b[sortedField]) return sortDirection ? -1 : 1;
        if(a[sortedField] > b[sortedField]) return sortDirection ?  1 : -1;
        return 0;
      })
    }
    return (
      <div className="group-container">
        <h2>{group.title}</h2>
        <table className="device-table">
          <tr>
            <td><b>Edit</b></td>
            <td><b>Online</b><button className="sort-button" onClick={() => changeSortedField('connected')}><span className={sortDirection ? 'rotate180' : ''}>^</span></button></td>
            <td><b>Serial</b><button className="sort-button" onClick={() => changeSortedField('serial')}><span className={sortDirection ? 'rotate180' : ''}>^</span></button></td>
            <td><b>Label</b><button className="sort-button" onClick={() => changeSortedField('label')}><span className={sortDirection ? 'rotate180' : ''}>^</span></button></td>
            <td><b>Admin</b><button className="sort-button" onClick={() => changeSortedField('admin')}><span className={sortDirection ? 'rotate180' : ''}>^</span></button></td>
            <td><b>Last Online</b><button className="sort-button" onClick={() => changeSortedField('updatedAt')}><span className={sortDirection ? 'rotate180' : ''}>^</span></button></td>
            <td><b>Model/DeviceName</b></td>
            <td><b>AndroidOS/PicoOS</b></td>
            <td><b>App Versions</b></td>
          </tr>
          <DeviceTable devices={gd} editDevice={props.editDevice} />
        </table>
      </div>
    )
  })

 return (
   <>
     {groups}
   </>
 )
}


function GroupedDeviceList(props){
  const groupdevices = []
  for(var i = 0;i<props.groups.length;i++){
    groupdevices[props.groups[i].id] = []
  }
  for(var j = 0;j<props.devices.length;j++){
    groupdevices[props.devices[j].GroupId].push(props.devices[j])
  }

  const groups = props.groups.map(group => {
    return (
      <div className="group-container">
        <h2>{group.title}</h2>
        <div className="grid">
          <DeviceList devices={groupdevices[group.id]} editDevice={props.editDevice} />
        </div>
      </div>
    )
  })

 return (
   <>
     {groups}
   </>
 )
}

function DeviceAppVersionsList(props){
  // map the data to JSX
  const versionlist = props.versions.map(version => (
    <p className="device-app-version" key={version.id}>{version.app.displayName} - { version.versionNumber }</p>
  ))

 return (
   <>
     {versionlist}
   </>
 )
}

function DeviceAppVersionsColumns(props){
  // map the data to JSX
  const versionlist = props.versions.map(version => (
    <div key={version.id}><b>{version.app.displayName}</b> - { version.versionNumber }</div>
  ))

 return (
   <td>
     {versionlist}
   </td>
 )
}

export default DevicesIndex;
